import OverallDevelopmentItem from './model';

export default OverallDevelopmentItem;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/items/index.js